import { StyledIconLarge } from "../StyledIcon/StyledIcon";
import { CardH1, CardText } from "../../styles/Typography";
import { StyledCard, StyledIconContainer } from "./Card.styles";

interface CardProps {
  icon?: any;
  title?: string;
  header?: string;
}

const Card: React.FC<CardProps> = ({ icon, title, header }) => {
  return (
    <StyledCard>
      <StyledIconContainer>
        <StyledIconLarge icon={icon} />
      </StyledIconContainer>
      <CardH1>{header}</CardH1>
      <CardText>{title}</CardText>
    </StyledCard>
  );
};

export default Card;
